import { envelopeDocumentContentPath, type SigningEnvelope } from '@dataroom/shared';

/**
 * Where the buyer reads the agreement an NDA/NC envelope wraps, before signing:
 * the envelope-scoped read (GET …/signing/envelopes/:envelopeId/document/content),
 * served to the envelope's own signer regardless of their tag grants — so a
 * teaser-stage buyer can read the NDA, which no grant of theirs covers.
 */
export function agreementContentPath(roomId: string, envelope: SigningEnvelope): string {
  return envelopeDocumentContentPath(roomId, envelope.id);
}
